import { render, staticRenderFns } from "./culture-base.vue?vue&type=template&id=a9088d26&"
import script from "./culture-base.vue?vue&type=script&lang=js&"
export * from "./culture-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports